
import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import {useWindowSize} from 'react-use';

import { Breakpoint, useTheme } from '@mui/system';
import { Card, CardContent, Container, useMediaQuery } from '@mui/material';

import { allProductsAtom, currentBasicTextFilterPropsAtom, currentFormNameAtom, currentUserSessionAtom, isSaveLoadingAtom } from 'library/store';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';


import { DatePicker } from '@mui/x-date-pickers';
import TextField, { TextFieldProps } from '@mui/material/TextField';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { flexBetween, flexBetweenCenter, flexCenter, justifyCenter, typographyGroupBoxStyling } from 'themes/commonStyles';

import useBillingService from 'features/finance/services/Billing';
import useProductService from 'features/setup/services/Product';

import {IBillingDashboardDate, IBillingDashboardMonth, defaultDashboardDate, defaultBillingDashboardMonth, defaultEmployeeBillingDashboard} from 'features/finance/models/Billing';



import { BasicTextFilterForm, defaultBasicTextFilterProps } from 'components/ui/BasicTextFilterForm';


import WidgetSummary from './widgets/WidgetSummary';
import WidgetBarChart from './widgets/WidgetBarChart';
import WidgetPieChart from './widgets/WidgetPieChart';
import { Button } from '@mui/material';
import { MdOutlineChangeCircle } from 'react-icons/md';
import { FormDialog } from 'components/ui/FormDialog';
import { EmployeeBillingDashboardForm } from './finance/EmployeeBillingDashboardForm';


import { KpiCard } from './widgets/KpiCard';
import { SaleBarChart } from './widgets/SaleBarChart';
import { SalesPieChart } from './widgets/SalesPieChart';
import { ExpiringPoliciesTable } from './widgets/ExpiringPoliciesTable';
import { PendingClaimsTable } from './widgets/PendingClaimsTable';
import { QuickActions } from './widgets/QuickActions';
import { getMonth, getYear } from 'date-fns';




export const Home = () => {

  const theme = useTheme();

  const { t, i18n } = useTranslation();

  const [currentFormName, setCurrentFormName] = useRecoilState(currentFormNameAtom);
  const [isSaveLoading, setIsSaveLoading] = useRecoilState(isSaveLoadingAtom);

  const {language: lg, applicationSetup, employeeId, userStores} = useRecoilValue(currentUserSessionAtom);
  const [allProducts, setAllProducts] = useRecoilState(allProductsAtom);


  const [currentBasicTextFilterProps, setCurrentBasicTextFilterProps] = useRecoilState(currentBasicTextFilterPropsAtom);

  const {height, width} = useWindowSize();
  const isSm = useMediaQuery( theme.breakpoints.down('sm'));

  const { getAllProducts } = useProductService();
  const {getDayDashboard, getMonthDashboard, getBasicMonthDashboard} = useBillingService();
  const [dashboard, setDashboard] = useState<IBillingDashboardMonth>(defaultBillingDashboardMonth);

  // const [openSchoolYearFilter, setOpenSchoolYearFilter] = useState(false);
  // const basicFilterSchoolYear = useBasicFilterSchoolYear( 
  //     async (event: React.MouseEvent<unknown>, row: ISchoolYear) => {
  //         const {id, name } = row;

  //         const dash = await getSchoolYearDashboard(id);
  //         setSchoolYearName(name);

  //         setDashboard(dash);
  //         setOpenSchoolYearFilter(false);
  //     }
  // );


  const handleClickSelectSchoolYear = (event: any) => {
    //setOpenSchoolYearFilter(true);
  }


  useEffect( () => {        
    setCurrentFormName(t('Home'));
    setCurrentBasicTextFilterProps(defaultBasicTextFilterProps);
    setIsSaveLoading(false);
  }, []);    

  const [dateFrom, setDateFrom] = React.useState<Date>(new Date());
  const [dateTo, setDateTo] = React.useState<Date>(new Date());


  const [date, setDate] = React.useState<Date>(new Date());

  useEffect(() => {
    async function _() {
            
      const y = getYear(date);
      const m = getMonth(date) + 1;

      const dash = await getBasicMonthDashboard(y, m);            
      setDashboard(dash);     

    }
    _();
  }, [date]);

  
  useEffect(() => {
    async function _() {
      
          // Here Load all product if allowed....
          if(applicationSetup.loadProductOnLogon && allProducts.length === 0){
            const storeId = userStores.find(x => x.isShowroom)?.id ?? 0;
            const arr = await getAllProducts(0, true, storeId,applicationSetup.defaultCurrencyCode);
            setAllProducts(arr);
            //alert(allProducts.length);
          } 
    }
    _();
  }, []);

  if(employeeId > 0) return ( <EmployeeBillingDashboardForm {...defaultEmployeeBillingDashboard} /> )

  
  return (
    <Box sx={{ p: 2 }}>
      {/* <Typography variant="h4" gutterBottom>Dashboard</Typography> */}

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <KpiCard title={t('Amount')} value={dashboard.amount} paletteColor={theme.palette['info']} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <KpiCard title={`${t('Amount paid')}`} value={dashboard.amountPaid} paletteColor={theme.palette['success']} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <KpiCard title={`${t('Unvalidated amount')}`} value={dashboard.unvalidatedAmount} paletteColor={theme.palette['warning']} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <KpiCard title={`${t('Cancelled amount')}`} value={dashboard.cancelledAmount} paletteColor={theme.palette['error']} />
        </Grid>
      </Grid>
      <Grid container spacing={1} sx={{ mt: 0.5, alignItems: 'flex-start' }}>
        <Grid item xs={12} sm={3}>
          <Card sx={{ p: 1, height: '100%' }}>
            <CardContent sx={{ p: 1 }}>
              <Typography variant="h6">{t('Quick access')}</Typography>

              <QuickActions />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <SalesPieChart title={t('Sales distribution')} label={t('Sales')} 
              labels={dashboard.lineOfBusinesses.map(x => x.lineOfBusinessName)}
              values={dashboard.lineOfBusinesses.map(x => x.amount)}
              
               />
        </Grid>
        
        <Grid item xs={12} sm={3}>
          8888
        </Grid>
      </Grid>
    </Box>
  )
}
